import { render, staticRenderFns } from "./StructureFormPage.vue?vue&type=template&id=02bacb12"
import script from "./StructureFormPage.vue?vue&type=script&lang=js"
export * from "./StructureFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports